export const OrSectionSeparator = (props: {
  case: string;
  className: string;
}) => {
  const orText = props.case == "lower" ? "or" : "OR";
  return (
    <div className={"or_treatment_container " + props.className}>
      <hr className="_margin-right--1rem _flex-grow--1" />
      <p className="_white-space--nowrap ">{orText}</p>
      <hr className="_margin-left--1rem _flex-grow--1" />
    </div>
  );
};
